module.exports = __webpack_public_path__ + "static/media/Parking-Active-Dark.9b3ca371.svg";